async function fetchReviews(storeName) {
  const url = `https://api.reviews.io/merchant/reviews?store=${storeName}`;
  try {
    const response = await fetch(url);
    return response.json();
  } catch (error) {
    console.error("Failed to fetch reviews", error);
  }
}

function initializeRatingSnippet(targetNodeSelector) {
  const targetNode = document.querySelector(targetNodeSelector);
  if (targetNode) {
    const observer = new MutationObserver(async (mutationsList, observer) => {
      const targetElement = targetNode.querySelector(
        ".rating-section .ReviewSummary__Count.Text.Text--Small",
      );

      if (targetElement) {
        observer.disconnect(); // Stop observing once the content is found

        // Fetch and process the reviews data
        const reviewData = await fetchReviews(window.halm.reviewsIoStoreName);
        const averageRating = parseFloat(
          reviewData?.stats.average_rating,
        ).toFixed(1);
        const totalReviews = reviewData?.stats?.total_reviews;
        const roundedToLower3Digit = Math.floor(totalReviews / 100) * 100;

        // Remove the existing rating count
        targetNode
          .querySelectorAll(
            ".rating-section .ReviewSummary__Count.Text.Text--Small",
          )
          .forEach((element) => element.classList.add("remove"));

        // add rating + rating count here instead
        targetNode
          .querySelectorAll(".Text.Text--Small:not(.remove)")
          .forEach((element) => {
            element.innerHTML = `<b>${averageRating}</b> (+${roundedToLower3Digit})`;
          });
      } else {
        console.error(
          `targetElement ${targetNode} .rating-section .ReviewSummary__Count.Text.Text--Small not found`,
        );
      }
    });

    // Configure the observer and start observing the targetNode for child additions/changes
    observer.observe(targetNode, { childList: true, subtree: true });
  } else {
    console.error(`Target node ${targetNodeSelector} not found`);
  }
}
